import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { paymentExpiry, readStoredJson } from './paymentSession';

export default function PaymentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const paymentLink = location.state?.paymentLink || sessionStorage.getItem("subscriptionPaymentLink");
  const summary = location.state?.summary || readStoredJson("subscriptionSummary");
  const session = location.state?.session || sessionStorage.getItem('subscriptionSession');
  const expiresAt = paymentExpiry(session);
  const [now, setNow] = useState(Date.now);
  const expired = !expiresAt || now >= expiresAt;
  const openedSession = useRef(null);
  if (!expired && paymentLink) openedSession.current = session;

  useEffect(() => {
    const check = () => setNow(Date.now());
    check();
    const timer = setInterval(check, 1000);
    window.addEventListener('focus', check);
    window.addEventListener('pageshow', check);
    document.addEventListener('visibilitychange', check);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', check);
      window.removeEventListener('pageshow', check);
      document.removeEventListener('visibilitychange', check);
    };
  }, [session]);

  useEffect(() => {
    const completed = event => {
      if (event.origin !== window.location.origin || event.data?.type !== 'subscription-completed' || event.data.session !== session) return;
      const params = new URLSearchParams(String(event.data.search || ''));
      if (params.get('session') !== session) return;
      navigate(`/completion?${params.toString()}`, { replace: true });
    };
    window.addEventListener('message', completed);
    return () => window.removeEventListener('message', completed);
  }, [session, navigate]);

  if (!paymentLink) {
    return (
      <main className="page" dir="rtl">
        <section className="panel">
          <img src="/logo.png" alt="Blue Parking" className="logo" />
          <h1>לא נמצא תשלום פעיל</h1>
          <button onClick={() => navigate("/")}>חזרה להתחלה</button>
        </section>
      </main>
    );
  }

  return (
    <main className="page payment-page" dir="rtl">
      <section className="payment-shell">
        <div className="payment-header">
          <button type="button" className="secondary" onClick={() => navigate("/")}>חזרה</button>
          <img src="/logo.png" alt="Blue Parking" className="payment-logo" />
          <div>
            <strong>{summary?.carId}</strong>
            {summary?.phoneNumber || summary?.userId ? (
              <span>{summary.phoneNumber || summary.userId}</span>
            ) : null}
            <span>
              {summary?.placeName} | {summary?.amount} ₪
              {summary?.couponCode ? ` | קופון ${summary.couponCode}` : ""}
              {Number(summary?.payments || 1) > 1 ? ` | ${summary.payments} תשלומים` : ""}
            </span>
          </div>
        </div>
        {expired ? <section className="payment-expired" role="status">
          <h1>פג תוקף התשלום</h1>
          <p>חלון התשלום נסגר. הפרטים שמילאת נשמרו ואפשר לפתוח תהליך חדש.</p>
          <p>אם כבר אישרת תשלום, יש לבדוק את העסקה מול התמיכה לפני תשלום נוסף.</p>
          <button type="button" onClick={() => navigate(`/subscription?place-id=${encodeURIComponent(summary?.placeId || '')}`)}>חזרה לפרטים ופתיחת תשלום חדש</button>
        </section> : <p className="payment-timeout" role="timer">תוקף חלון התשלום: {Math.ceil((expiresAt - now) / 60000)} דקות</p>}
        {/* Keep an already-open frame alive to receive a late provider redirect,
            but remove it from view and keyboard navigation after expiry. */}
        {!!openedSession.current && openedSession.current === session && <iframe
          allow="payment *"
          title="PayPlus"
          src={paymentLink}
          className="payment-frame"
          style={expired ? { display: 'none' } : undefined}
          tabIndex={expired ? -1 : undefined}
          aria-hidden={expired ? true : undefined}
        />}
      </section>
    </main>
  );
}
